// extracted by mini-css-extract-plugin
export default {"LoginAuthorized":"LoginAuthorized_LoginAuthorized__7BYsQ"};